import React, { useState } from 'react';
import { QuillEditor } from '../../../components/common/quill-editor/quill-editor';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import { Delete, ExpandMore, ExpandLess } from '@mui/icons-material';

interface IProps {
  value: string[];
  onChange: (_value: string[]) => void;
}

const TetxArrayFields = ({ value, onChange }: IProps) => {
  const clonedValue = structuredClone(value) as string[];
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const toggleExpand = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const removeText = (index: number) => {
    const updatedContent = [...clonedValue];
    updatedContent.splice(index, 1);
    onChange(updatedContent);
    if (expandedIndex === index) setExpandedIndex(null);
  };
  return (
    <FieldLabel
      label={
        (
          <CustomTooltip title="Text">
            <span>Text</span>
          </CustomTooltip>
        ) as React.ReactNode as string
      }
      className="border p-2 border-gray-700"
      el="div">
      <>
        {clonedValue?.map((Item, index) => (
          <div key={index} className="p-2 border border-gray-700">
            <div
              className="flex items-center justify-between p-2 hover:bg-gray-700 cursor-pointer"
              onClick={() => toggleExpand(index)}>
              <span>{'Item ' + (index + 1)}</span>
              <div className="flex gap-2">
                <Delete
                  className="w-4 h-4 text-gray-400 hover:text-red-500 cursor-pointer"
                  onClick={e => {
                    e.stopPropagation();
                    removeText(index);
                  }}
                />
                {expandedIndex === index ? (
                  <ExpandMore className="w-4 h-4 text-gray-400" />
                ) : (
                  <ExpandLess className="w-4 h-4 text-gray-400" />
                )}
              </div>
            </div>
            {expandedIndex === index && (
              <div className="p-2 flex justify-between items-center">
                <div key={index}>
                  <QuillEditor
                    value={Item}
                    onChange={val => {
                      // Create a DOM parser to parse the string into a DOM object
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(val, 'text/html');

                      // Find all <a> tags
                      const anchorTags = doc.querySelectorAll('a');

                      // Loop through each <a> tag and modify the style if needed
                      anchorTags.forEach(anchor => {
                        const style = anchor.getAttribute('style');
                        if (!style || !style.includes('color')) {
                          anchor.style.color = 'black'; // Apply default black color if missing
                        }
                      });
                      const updatedContent = [...clonedValue];
                      updatedContent[index] = doc.body.innerHTML;
                      onChange(updatedContent);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        ))}
        <button
          className="w-full p-2 text-center text-gray-400 hover:text-white hover:bg-gray-700 border border-gray-700"
          onClick={() => onChange([...clonedValue, ''])}>
          +
        </button>
      </>
    </FieldLabel>
  );
};

export default TetxArrayFields;
